import { Pipe, PipeTransform } from '@angular/core';
import { DisplayDecorator } from '../../decorators/display-decorator';
import { ODataModel } from '../../interfaces/odata-model.interface';

@Pipe({
    name: 'searchFilter',
})
export class SearchFilterPipe implements PipeTransform {
    public transform(
        items: Array<DisplayDecorator<ODataModel>>,
        filter: { search: string },
    ): Array<DisplayDecorator<ODataModel>> {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(
            (item) => item.displayName.toLocaleLowerCase().indexOf(filter.search.toLocaleLowerCase()) !== -1,
        );
    }
}
